import React, { useContext, useEffect, useState } from "react";
import {
  Badge,
  LegacyCard as Card,
  Text,
  Collapsible,
  FormLayout,
  Icon,
  Layout,
  Link,
  InlineStack,
  TextField,
} from "@shopify/polaris";
import { AlertTriangleIcon } from "@shopify/polaris-icons";
import { useQuery } from "@apollo/client";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import helper
import { baseHelper, errorHelper } from "lib/helpers";

// import contexts
import { PrivateContext } from "lib/context";

import constant from "lib/constant/constant";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

import { GET_USER } from "app/setup/apollo/queries";
import { useNavigate } from "react-router-dom";

const Domain = () => {
  const {
    domain,
    handleChange,
    //  learnMore
    setBanner,
  } = useContext(BrandingContext);
  const { currentUser = {}, cms = () => {} } = useContext(PrivateContext);
  const navigate = useNavigate();
  const { /* plan */ updatedAt = "" } = currentUser;

  const {
    gql: { GET_USER: GET_USER_GQL },
    DOMAIN,
  } = constant;
  const isGrowthAndAbovePlan = true; // baseHelper.isGrowthAndAbovePlan({ plan });
  const { data: getUserData, error: getUserError } = useQuery(GET_USER);
  const [isStripeConnected, setIsStripeConnected] = useState(false);
  const badge = [
    {
      content: !isGrowthAndAbovePlan && (
        <InlineStack wrap={false}>
          <Badge status="warning">{cms("message.growthAndAbove")}</Badge>
          <Icon source={AlertTriangleIcon} color="black" />
        </InlineStack>
      ),
    },
  ];

  useEffect(() => {
    if (getUserData) {
      const resData = baseHelper.getResponseData(getUserData, GET_USER_GQL);
      const resError = baseHelper.getResponseError(getUserData, GET_USER_GQL);
      if (resError) {
        setBanner({
          isOpen: true,
          status: "critical",
          title: resError,
        });
      }
      if (resData) {
        const stripeValues = (resData && resData.stripeKey) || null;
        setIsStripeConnected(!!(stripeValues && stripeValues.clientId && stripeValues.secret));
      }
    }
    if (getUserError) {
      setBanner({
        isOpen: true,
        status: "critical",
        title: errorHelper.parse(getUserError),
      });
    }
  }, [getUserData, setBanner, GET_USER_GQL, getUserError, cms]);

  const planContent = cms("section.domain.content.caption.plan").map(
    (planCMS) =>
      planCMS &&
      planCMS.content &&
      ((planCMS.link && (
        <Link key={planCMS.id} onClick={() => navigate(planCMS.link)}>
          {planCMS.content}
        </Link>
      )) ||
        planCMS.content)
  );

  return (
    <>
      <Collapsible open>
        <Layout.AnnotatedSection title={cms("section.domain.title")} description={cms("section.domain.description")}>
          <Card
            sectioned
            title={[
              cms("section.domain.content.title"),
              updatedAt && (
                <Text as="span" tone="subdued">
                  <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
                </Text>
              ),
            ]}
            actions={[
              badge,
              // { content: "Learn more", onAction: () => learnMore(cms("section.domain.content.title"), "TODO: ") },
            ]}
          >
            <FormLayout>
              <TextField
                id="domain"
                disabled={!isGrowthAndAbovePlan}
                placeholder={cms("section.domain.placeholder.domain")}
                value={domain}
                onChange={(value) => handleChange(DOMAIN, value, DOMAIN)}
              />
            </FormLayout>
            <br />
            <Text variant="bodySm" as="p">
              {cms("section.domain.content.caption.domain")}
            </Text>
            {isStripeConnected && [
              <br />,
              <Text variant="bodySm" as="p">
                {cms("section.domain.content.caption.stripe")}
              </Text>,
            ]}
            {!isGrowthAndAbovePlan && [
              <br />,
              <Text variant="bodySm" as="p">
                {planContent}
              </Text>,
            ]}
          </Card>
        </Layout.AnnotatedSection>
      </Collapsible>
    </>
  );
};

export default withFeature(withErrorBoundary(Domain), {
  feature: constant.DOMAIN_BRANDING,
});
